import {
  getByYearAndMonth as getByYearAndMonthApi
} from '@mizz/penny-firebase/repositories/budgets'
import { getCurrentUserId } from './auth'

export async function getByYearAndMonth(year, month) {
  const budget = await getByYearAndMonthApi(year, month, getCurrentUserId())
  return budget
}
